<template>
  <div>
    <div class="page-header">
      <div class="container-fluid d-flex align-items-center justify-content-between">
       <h2 class="h4 no-margin-bottom">Kullanıcı Listesi</h2>
       <div class="right-menu list-inline no-margin-bottom">
          <router-link to="/create/kullanici"><button type="submit" class="btn submit bg-dark text-light">Yeni Kullanıcı</button>
          </router-link>
       </div>
      </div>
    </div>

  <section class="no-padding-top no-padding-bottom">
    <div class="row mb-2 p-2">
          <div class="col-lg-8 col-12">
          </div>
      <div class="col-4">
          <input class="form-control" placeholder="Genel Arama" id="arama" type="text" @keyup="this.$helper.tabloarama"/>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
         <div class="block margin-bottom-sm">
            <div class="table-responsive"> 
               <table id="tablo" class="table table-striped">
                  <thead>
                    <tr>
                      <th>Tipi</th>
                      <th>Kullanıcı</th>
                      <th>Telefon</th>
                      <th>E-Posta</th>
                      <th>Depo</th>
                      <th>Düzenle</th>
                      <th>Detay</th>
                    </tr>
                  </thead>
                  <tbody>
                   <tr v-for="post in posts" :key="post.id">
                    <td class="dashtext-3">{{post.tip}}</td>
                    <td>{{post.isim}}</td>
                    <td>{{post.tel}}</td>
                    <td>{{post.eposta}}</td>
                    <td>{{post.depo}}</td>
                    <td v-if="$helper.sayfayetki(487002)"  class="text-info">
                      <router-link :to="`/duzen/kullanici/${post.kid*8589+'bn'+post.ktid*8846}`">Düzenle</router-link>
                    </td>
                    <td v-if="$helper.sayfayetki(487002)"  class="dashtext-1">
                      <router-link :to="`/detay/kullanici/${post.kid*8589+'bn'+post.ktid*8846}`">Detay</router-link>
                    </td>
                   </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    <div v-if="progres.inprogres">
      <div id="spinner-front" class="show"> <img src="/set/ajax-loader.gif"/><br>{{progres.mesaj}} ...</div>
      <div id="spinner-back" class="show"></div>
    </div>       
    </div>
</template>
<script>
  export default {
    created() {
      this.progres.inprogres = true
      this.yetki();
    },
    data() {
      return {
        progres : {
          mesaj:'Bekleyiniz',
          inprogres:false
        } ,              
        inProgress: false,
        search: '',
        posts: [],
        errors: [],
        currentTag :'All',
        firma:this.$request.ayar().firmaid
      };
    },
    computed : {

    },
    methods: {
          yetki: function(){
          if (this.$helper.sayfayetki(845326)){
            this.getPostsAsync()
          }
          else{
            alert('Bu alanı kullanım yetkiniz yok')
            this.$router.go(-1)
          }
        },
      getPostsAsync() { 
        this.$request.get("kullanici/"+this.firma)
        .then(res => {this.posts = res.results
        this.progres.inprogres = false
        })
        .catch(err => {this.errors.push(err)})
      },
        filter: function(tag) {
          this.currentTag = tag;
        },
        filteredItems: function(array,field) {
        var filter = this.currentTag;
        if (filter == 'All' ){
            return array
        }
        else{
              return array.filter(function(item) {
              return item[field].indexOf(filter) !== -1;
          });
        }
        },      
    }

  };
</script>
<style scoped>
@media
	  only screen 
    and (max-width: 760px), (min-device-width: 768px) 
    and (max-device-width: 1024px)  {
		table, thead, tbody, th, td, tr {
			display: block;
		}
		thead tr {
			position: absolute;
			top: -9999px;
			left: -9999px;
		}
    tr {
      margin: 0 0 1rem 0;
    }
    tr:nth-child(odd) {
      background: #ccc;
    }
		td {
			border: none;
			border-bottom: 1px solid #eee;padding-left: 50%;
			position: relative;
		}
		td:before {
			position: absolute;
			top: 0;
			left: 6px;
			width: 45%;
			padding-right: 10px;
			white-space: nowrap;
		}
		td:nth-of-type(1):before { content: "id"; }
		td:nth-of-type(2):before { content: "Alias"; }
		td:nth-of-type(3):before { content: "Model"; }
		td:nth-of-type(4):before { content: "Barkod"; }
		td:nth-of-type(5):before { content: "Cari"; }
		td:nth-of-type(6):before { content: "Durum"; }
		td:nth-of-type(7):before { content: "Detay"; }
	}
@media screen and (min-width: 992px) and (max-width: 2000px) {
table, td, th {  
  /*border: 1px solid #ddd;*/
  text-align: left;
}
table {
  border-collapse: collapse;
  width: 100%;
}
th, td {
  padding:15px;
}
}
</style>



// WEBPACK FOOTER //
// src/views/kullanici/liste.vue